const theme = {
  bg: "#f0ede8",
  bgAlt: "#e8e4de",

  primary: "#a0620a",
  primaryDark: "#7a4a06",
  primaryLight: "rgba(160, 98, 10, 0.1)",
  primaryGlow: "rgba(160, 98, 10, 0.18)",

  cardBg: "#ffffff",
  cardBorder: "#e2ddd6",
  cardBorderStrong: "#ccc5bb",

  textMain: "#1c1710",
  textSub: "#3a3028",
  textMuted: "#9a9088",

  danger: "#c0392b",
  dangerLight: "rgba(192, 57, 43, 0.08)",
  success: "#2e7d4f",

  inkLine: "#1c1710",
  separator: "#e2ddd6",

  sidebarBg: "#ffffff",
  sidebarWidth: "240px",
};

export default theme;
